module.exports = __webpack_public_path__ + "img/rolling-credit-comments.829f41a2.png";